import { Component, OnInit } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { ActivatedRoute } from '@angular/router';
import { ProcessToken } from './core/models/process-token';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  checked = false;
  activeButtons = true;
  signatoryName: string;
  signatoryEmail: string;
  timeOut = true;
  action = false;
  hideContinue = false;
  selectedLanguage: string;

  // URL constants
  private readonly SPAIN_URL = 'psa-esign-esp';
  private readonly PORTUGAL_URL = 'psa-esign-pt';

  // Language constants
  private readonly SPAIN_LANGUAGE = 'sp';
  private readonly PORTUGAL_LANGUAGE = 'por';
  private readonly FRANCE_LANGUAGE = 'fr';

  showDropdown = false;
  languages = [
    { code: 'en', flag: 'en.svg', langue: 'English' },
    { code: 'fr', flag: 'fr.svg', langue: 'Français' },
    { code: 'sp', flag: 'sp.svg', langue: 'Español' },
    { code: 'por', flag: 'por.svg', langue: 'Português' },
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // Initialize default language based on URL
    const hostname = window.location.hostname;

    if (hostname.includes(this.SPAIN_URL)) {
      this.selectedLanguage = this.SPAIN_LANGUAGE;
    } else if (hostname.includes(this.PORTUGAL_URL)) {
      this.selectedLanguage = this.PORTUGAL_LANGUAGE;
    } else {
      this.selectedLanguage = this.FRANCE_LANGUAGE;
    }

    // Check if there is a saved language in localStorage
    let lang = localStorage.getItem('selectedLanguage');
    if (lang) {
      this.changeLanguage(lang);
    } else {
      this.translate.setDefaultLang(this.selectedLanguage);
      this.translate.use(this.selectedLanguage);
      localStorage.setItem('selectedLanguage', this.selectedLanguage);
    }
  }
  // Méthode pour basculer l’affichage du menu
  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }
  // Méthode pour changer la langue
  changeLanguage(lang: string): void {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
    this.showDropdown = false;
  }
  enableSign(value: boolean): void {
    this.activeButtons = !value;
    this.hideContinue = true;


  }
  receiveSignRefuse(action: boolean) {
    this.action = action;
  }


  receiveprofilInformation(processToken: ProcessToken) {
    if (isNotNullOrUndefined(processToken)) {
      this.signatoryEmail = processToken.signatoryEmail;
      this.signatoryName = processToken.signatoryName;

    }
  }
  receiveTimeOut(isValid: boolean) {
    this.timeOut = isValid;
  }
}
